import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';

import { Reservation } from '../models/reservation';
import { Dish } from '../models/dish';
import { environment } from '../../environments/environment';

@Injectable()
export class ReservationService {
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private httpClient: HttpClient, private http: Http) { }

  addReservation(reservation: Reservation): Observable<any> {
    return this.httpClient.post(environment.apiBaseUrl + '/reservations/', JSON.stringify(reservation), {headers: this.headers});
  }

  getReservation(reference: string): Observable<Reservation> {
    return this.httpClient.get<Reservation>(environment.apiBaseUrl + '/reservations/byref/' + reference);
  }

  getDishes(): Observable<Dish[]> {
    return this.httpClient.get<Dish[]>(environment.apiBaseUrl + '/specs/dish');
  }
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/services/reservation.service.ts